(() => {
  const sortCards = (list, cards) => {
    cards
      .sort((a, b) => {
        const priority = Number(a.dataset.storePriority || 2) - Number(b.dataset.storePriority || 2);
        if (priority) return priority;
        const title = (card) => card.querySelector('[data-store-locator-location]')?.textContent || '';
        return title(a).localeCompare(title(b));
      })
      .forEach((card, index) => {
        card.dataset.storeIndex = String(index);
        list.append(card);
      });
  };
  const init = (root) => {
    if (!root || root.dataset.storeLocatorReady === 'true') return;
    root.dataset.storeLocatorReady = 'true';

    const find = (selector) => root.querySelector(selector);
    const cards = [...root.querySelectorAll('[data-store-locator-card]')];
    const list = find('[data-store-locator-list]');
    const pinsContainer = find('[data-store-locator-pins]');
    const mapElement = find('[data-store-locator-google-map]');
    const mapMessage = find('[data-store-locator-map-message]');
    const mapRetry = find('[data-store-locator-map-retry]');
    const searches = [...root.querySelectorAll('[data-store-locator-search]')];
    const city = find('[data-store-locator-city]');
    const status = find('[data-store-locator-status]');
    const toggle = find('[data-store-locator-toggle]');
    const detailBack = find('[data-store-locator-detail-back]');
    let pins = [];
    let mapController = null;

    if (list) sortCards(list, cards);
    if (city) {
      const values = new Map();
      cards.forEach((card) => {
        const key = card.dataset.storeCity || '';
        const label = card.dataset.storeCityLabel || '';
        if (key && label && !values.has(key)) values.set(key, label);
      });
      [...values.entries()]
        .sort((a, b) => a[1].localeCompare(b[1], document.documentElement.lang || undefined))
        .forEach(([value, label]) => city.add(new Option(label, value)));
    }
    const applyFilters = (source) => {
      const value = source?.value ?? searches[0]?.value ?? '';
      searches.forEach((input) => {
        if (input !== source && input.value !== value) input.value = value;
      });
      const query = value.trim().toLocaleLowerCase(document.documentElement.lang || undefined);
      const selectedCity = city?.value || '';
      let visible = 0;
      cards.forEach((card) => {
        const matchesQuery = !query || (card.dataset.storeSearch || card.textContent || '')
          .toLocaleLowerCase(document.documentElement.lang || undefined)
          .includes(query);
        const matchesCity = !selectedCity || card.dataset.storeCity === selectedCity;
        card.hidden = !(matchesQuery && matchesCity);
        pins.find((pin) => pin.dataset.storeIndex === card.dataset.storeIndex)?.toggleAttribute('hidden', card.hidden);
        if (!card.hidden) visible += 1;
      });
      mapController?.setVisible(cards.map((card) => !card.hidden));
      if (status) {
        const label = root.dataset.storeLocatorResultsLabel || '{count}';
        status.textContent = visible ? label.replace('{count}', String(visible)) : root.dataset.storeLocatorEmptyLabel || '';
      }
    };
    const setView = (view) => {
      root.dataset.activeView = view;
      root.classList.remove('is-detail-view');
      if (toggle) toggle.textContent = view === 'map' ? root.dataset.storeLocatorListLabel : root.dataset.storeLocatorMapLabel;
    };
    const selectStore = (index, openDetail = false, focusMap = false) => {
      cards.forEach((card) => card.classList.toggle('is-selected', card.dataset.storeIndex === String(index)));
      pins.forEach((pin) => pin.classList.toggle('is-selected', pin.dataset.storeIndex === String(index)));
      mapController?.select(Number(index), focusMap);
      if (openDetail && window.matchMedia('(max-width: 749px)').matches) {
        setView('list');
        root.classList.add('is-detail-view');
        find(`[data-store-locator-card][data-store-index="${CSS.escape(String(index))}"]`)?.scrollIntoView({ block: 'start' });
      }
    };
    searches.forEach((input) => input.addEventListener('input', () => applyFilters(input)));
    city?.addEventListener('change', () => applyFilters(searches[0]));
    toggle?.addEventListener('click', () => setView(root.dataset.activeView === 'map' ? 'list' : 'map'));
    cards.forEach((card) => card.querySelector('[data-store-locator-select]')
      ?.addEventListener('click', () => selectStore(card.dataset.storeIndex, true, true)));
    detailBack?.addEventListener('click', () => root.classList.remove('is-detail-view'));

    const apiKey = root.dataset.googleMapsApiKey || '';
    const startMap = () => {
      if (!apiKey || !mapElement || !window.LEStoreGoogleMap) return;
      root.classList.remove('is-google-map-ready');
      window.LEStoreGoogleMap.setState(mapMessage, mapRetry, root.dataset.storeLocatorMapLoadingLabel || '', false);
      window.LEStoreGoogleMap.init({
        apiKey,
        cards,
        element: mapElement,
        onSelect: (index) => selectStore(index, true, true),
      }).then((controller) => {
        mapController = controller;
        root.classList.add('is-google-map-ready');
        selectStore(0);
        applyFilters(searches[0]);
      }).catch(() => {
        window.LEStoreGoogleMap.setState(mapMessage, mapRetry, root.dataset.storeLocatorMapErrorLabel || '', true);
      });
    };
    mapRetry?.addEventListener('click', startMap);
    if (apiKey && mapElement && window.LEStoreGoogleMap) {
      startMap();
    } else {
      pins = window.LEStoreGoogleMap?.createFallbackPins(pinsContainer, cards, selectStore) || [];
    }
    applyFilters(searches[0]);
    if (cards.length) selectStore(0);
  };
  const initAll = (scope = document) => scope.querySelectorAll('[data-store-locator]').forEach(init);
  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})()
